module.exports = __webpack_public_path__ + "static/media/grayson.d1e75653.png";